import React, { useState } from "react";
import TicketList from "./tickets/TicketList";
import TicketSummary from "./tickets/TicketSummary";
import TicketSearch from "./tickets/TicketSearch";
import MyTicketSummary from "./tickets/MyTicketSummary";
const Dashboard = () => {
  const [searchParams, setSearchParams] = useState({});

  const handleSearch = (params) => {
    setSearchParams(params);
  };

  return (
    <div>
      <section className="bg-white shadow-md p-4 rounded-lg mb-4">
      <h2 className="text-gray-400 text-lg text-center font-semibold mb-4">Summary</h2>
        <hr />
        <TicketSummary />
      </section>
      <section className="bg-white shadow-md p-6 rounded-lg mb-6">
        <h2 className="text-gray-400 text-lg text-center font-semibold mb-4">My Summary</h2>
        <hr />
        <MyTicketSummary onSearch={handleSearch} />
      </section>
      <TicketSearch onSearch={handleSearch} />
      <section className="bg-white shadow-md p-6 rounded-lg mb-6">
        <h2 className="text-gray-700 text-lg font-semibold mb-4">Ticket List</h2>
        <div className="overflow-x-auto">
          <TicketList searchParams={searchParams} />
        </div>
      </section>
    </div>
  );
};

export default Dashboard;

